import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getState = createFeatureSelector<State>('members');

export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getMembers = createSelector(
  getState,
  (state: State) => state.data
);

